import axios from "axios";
import { TREASURY_ENDPOINTS } from "./treasuryConstants";

/**
 * Fetches the per-channel treasury position.
 * @returns {Promise<Object>} { generated_at, currencies, channels, cross_currency }
 */
export async function fetchTreasuryChannels() {
    const { data } = await axios.get(TREASURY_ENDPOINTS.channels);
    return data;
}
